export default "__VITE_ASSET__$YLulN$S__"